export default __webpack_public_path__ + "static/logo-d07b66a87d06a98e369be24ae87dfee2.svg";